import * as Yup from 'yup';

export default Yup.object({
  emailAddress: Yup.string().email('Invalid email address'),
});
